import { Store } from '@ngxs/store'
import { Injectable } from '@angular/core'
import { GetMessages } from '../store/actions/message.actions'
import { GetStudentAuditDocuments } from '../store/actions/student-audit-documents.actions'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ThrottleService {
  constructor(private store: Store) {}
  getMessagesLastCalled: number
  getDocumentsLastCalled: number
  throttlePause
  getMessages() {
    const now = new Date().valueOf()
    const elapsed = now - this.getMessagesLastCalled
    if (
      elapsed > environment.throttle.getMessages ||
      !this.getMessagesLastCalled
    ) {
      this.store.dispatch(new GetMessages())
      this.getMessagesLastCalled = new Date().valueOf()
    }
  }
  getDocuments() {
    const now = new Date().valueOf()
    const elapsed = now - this.getDocumentsLastCalled
    if (
      elapsed > environment.throttle.getDocuments ||
      !this.getDocumentsLastCalled
    ) {
      this.store.dispatch(new GetStudentAuditDocuments())
      this.getDocumentsLastCalled = new Date().valueOf()
    }
  }

  throttle(callback, time) {
    if (this.throttlePause) return
    this.throttlePause = true
    setTimeout(() => {
      callback()
      this.throttlePause = false
    }, time)
  }
}
